import styles from "../../styles/DropDownLoggedInHeader.module.css";

const UserImage = ({ image, mobileView, toggleDropdown }) => {
  return (
    <img
      src={image ? image : "/icons/bidd/profileAvatar.svg"}
      className={`${mobileView && styles.avatar} ${
        !mobileView && styles.ReviewRatingDropDownArrow
      } ${!mobileView && toggleDropdown === true && styles.selectedArrow}`}
      alt="avatar"
    />
  );
};

export default UserImage;
